import { render } from "./personal-loan.vue?vue&type=template&id=35d8c5a7"
import script from "./personal-loan.vue?vue&type=script&lang=js"
export * from "./personal-loan.vue?vue&type=script&lang=js"

import "./personal-loan.vue?vue&type=style&index=0&id=35d8c5a7&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__